var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { BUY_LABEL_REQUEST, buyLabelFailure, buyLabelSuccess, } from "@/redux/actions";
import APIIN from "../../../utils/APIIN";
export const onBuyLabel = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            console.log("payload", action.payload);
            APIIN.post(`cnvt/shipment/buy`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* buyLabelWorker(action) {
    try {
        const data = yield call(onBuyLabel, action);
        yield put(buyLabelSuccess(data));
    }
    catch (error) {
        yield put(buyLabelFailure(error));
    }
}
export function* watchBuyLabelData() {
    yield takeLatest(BUY_LABEL_REQUEST, buyLabelWorker);
}
